var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V9M20 6V9M7.5 13.09H24.5M19.6947 17.7H19.7037M19.6947 20.7H19.7037M15.9955 17.7H16.0045M15.9955 20.7H16.0045M12.2943 17.7H12.3033M12.2943 20.7H12.3033M25 12.5V21C25 24 23.5 26 20 26H12C8.5 26 7 24 7 21V12.5C7 9.5 8.5 7.5 12 7.5H20C23.5 7.5 25 9.5 25 12.5Z",
    stroke: "#9BA3AB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.68377ff4ea30ce9854d4f7dd763f6766.svg";
export { ForwardRef as ReactComponent };